export const cargoTypesByKey = {
  bulk: 'Bulk',
  breakbulk: 'Breakbulk',
};

export const cargoTypes = Object.values(cargoTypesByKey);
